import req from 'utils/req';

import {
  PayoutMethodsApi,
  PayoutMethodsByCountryApi,
} from '../models/PayoutMethods';

export function getByCountry({ countryCode }: { countryCode: string }) {
  return req(
    `${URL_API_HOST}/api/v1/finance/payout-methods/${countryCode}`,
  ).get() as Promise<PayoutMethodsApi>;
}

export function getAll() {
  return req(
    `${URL_API_HOST}/api/v1/finance/payout-methods`,
  ).get() as Promise<PayoutMethodsByCountryApi>;
}
